import React, { useMemo } from 'react'
import CobaltMappingForm from './CobaltMappingForm';
import CobaltCredentialForm from './CobaltCredentialForm';
import GenericPullConfigListing from '../GenericPullConfigListing';
import { columnRenderArrayData } from 'utils/tableUtils';

export default function CobaltConfigListing(props) {

    const columns = useMemo(() => [{
            title: "Organization",
            dataIndex: "organizationName",
            render: columnRenderArrayData,
            width: 200
        },
        {
            title: "Pentest",
            dataIndex: "pentestName",
            render: columnRenderArrayData,
            width: 200
        },
    ], [])

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            extraColumns={columns}
            MappingForm={CobaltMappingForm}
            CredentialsForm={CobaltCredentialForm}
            displayComponentName="Organization"
        />
    )
}